export default "__VITE_ASSET__DPJT8JFa__"